import { triniumApi } from '@api/Trinium/slice';

export interface Chassis {
	id: string;
	ownerId: string;
}

const chassisSlice = triniumApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchChassis: builder.query<Chassis[], { terminalNumber: string; status?: string }>({
			query: ({ terminalNumber, status }) => ({
				url: `${terminalNumber}/chassis`,
				params: status ? { status } : undefined
			})
		})
	})
});

export const { useFetchChassisQuery } = chassisSlice;
